import { render, staticRenderFns } from "./topicSelect.vue?vue&type=template&id=94b360f6&scoped=true"
import script from "./topicSelect.vue?vue&type=script&lang=js"
export * from "./topicSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94b360f6",
  null
  
)

export default component.exports